// extracted by mini-css-extract-plugin
export default {"fileName":"stACWk0q7v"};